import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";

export default function MoonlightvaleFooter() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 100,
      );
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`footer ${show ? "show" : ""}`}>
      <footer id="footer" className="moon-footer">
        {/* Moon */}
        <div className="moon" />

        <Container className="py-4 position-relative">
          <Row className="g-4">
            <Col md={3}>
              <h4>LunaPlane</h4>
              <p className="text-muted">
                A city under the Moonlight, where everyday tells a a story.
              </p>
            </Col>

            <Col md={3}>
              <h6>Explore</h6>
              <div className="d-flex flex-column gap-1">
                <h6 >Home</h6>
                <h6 href="#">About</h6>
                <h6 href="#">Users</h6>
              </div>
            </Col>

            <Col md={3}>
              <h6>Community</h6>
              <div className="d-flex flex-column gap-1">
                <h6 >Discord</h6>
                <h6 >Events</h6>
                {/* <a href="#">Discord</a>
                <a href="#">Events</a> */}
              </div>
            </Col>

            <Col md={3}>
              <h6>Contact</h6>
              <div className="d-flex flex-column gap-1">
                <a href="mailto:info@lunaplane.com">Email</a>
                <a href="mailto:info@lunaplane.com">Support</a>
                <Link to="/privacy">Privacy Policy</Link>
                <Link to="/terms-condition">Terms and Conditions</Link>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="bottom">© 2026 LunaPlane. All rights riserved.</div>
      </footer>
    </div>
  );
}
